import { EModeDialogContentContainer } from './EModeDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { EModeCategoryId } from '@/features/sparklend/common/data/market-info/emode'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

interface EModeDialogProps extends CommonDialogProps {
  userEModeCategoryId: EModeCategoryId
}

function EModeDialog({ open, setOpen, userEModeCategoryId }: EModeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <EModeDialogContentContainer userEModeCategoryId={userEModeCategoryId} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const eModeDialogConfig: DialogConfig<EModeDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: EModeDialog,
  name: 'EModeDialog',
}
